import { Slide, TableOptions } from '@features/powerpoint';
import {
  MinimumsTableData,
  minimumsTable,
} from '../../components/minimums-table';

const data = {
  headers: ['LCI® Report Dimension', 'Minimum Pageview Requirement*'],
  body: [
    ['Lift Conversion Index® - Overall Website', '25M Pageviews**'],
    ['Lift Conversion Index® - By Website Category', '25M per category'],
    ['Lift Conversion Index® - By Webpage', '25M per webpage'],
    ['Lift Conversion Index® - By Other Dimension', '25M per dimension'],
  ],
} as const satisfies MinimumsTableData;

type DimensionTableProps = {
  options: TableOptions;
};

export const dimensionTable = (props: DimensionTableProps): Slide =>
  minimumsTable({ data, options: props.options });
